// ----------------------------------------------------------------------
// <copyright file="Izenda.DataModelConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import localizer from 'share/localization/Izenda.Localizer';

export default {
  get MENU() {
    return [
      {
        key: 'tables',
        icon: 'icon-table',
        title: localizer.getText('DATA_MODEL_CONSTANTS_TITLE_MENU_TABLE'),
        backendType: 'Table'
      },
      {
        key: 'views',
        icon: 'icon-view-table',
        title: localizer.getText('DATA_MODEL_CONSTANTS_TITLE_MENU_VIEW'),
        backendType: 'View'
      },
      {
        key: 'storeprocedures',
        icon: 'icon-sp',
        title: localizer.getText('DATA_MODEL_CONSTANTS_TITLE_MENU_STORED_PROCEDURES'),
        backendType: 'Stored Procedure'
      },
      {
        key: 'functions',
        icon: 'icon-fx-table',
        title: localizer.getText('DATA_MODEL_CONSTANTS_TITLE_MENU_FUNCTIONS'),
        backendType: 'Function'
      },
      {
        key: 'relationship',
        icon: 'icon-relationship',
        title: localizer.getText('DATA_MODEL_CONSTANTS_TITLE_MENU_RELATIONSHIP'),
        backendType: 'Relationship'
      }
    ];
  },

  QUERY_SOURCE_TYPE: {
    TABLE: 'tables',
    VIEW: 'views',
    STOREPROCEDURES: 'storeprocedures',
    FUNCTIONS: 'functions',
    RELATIONSHIP: 'relationship',
    SCHEMA: 'schema'
  },

  DETECTED_CHANGE_LEVEL: {
    NONE: 0,
    ADDED: 1,
    MODIFIED: 2,
    DELETED: 3
  },

  APPROVAL_LEVEL: {
    PENDING: 0,
    QUERY_SOURCE: 1,
    QUERY_SOURCE_FIELD: 2
  },
  get DELETED_FUNCTION() {
    return localizer.getText('DATA_MODEL_CONSTANTS_DELETED_FUNCTION');
  },

  get FUNCTION_CHANGE() {
    return localizer.getText('DATA_MODEL_CONSTANTS_FUNCTION_CHANGE');
  },

  get FUNCTION_ADD() {
      return localizer.getText('DATA_MODEL_CONSTANTS_FUNCTION_ADD');
  },
  get NEW_DATA_SOURCE() {
    return localizer.getText('DATA_MODEL_CONSTANTS_NEW_DATA_SOURCE');
  },
  get DATA_SOURCE_CHANGES() {
    return localizer.getText('DATA_MODEL_CONSTANTS_DATA_SOURCE_CHANGES');
  },
  get DELETED_DATA_SOURCE() {
    return localizer.getText('DATA_MODEL_CONSTANTS_DELETED_DATA_SOURCE');
  },
  get NEW_FIELD() {
    return localizer.getText('DATA_MODEL_CONSTANTS_NEW_FIELD');
  },
  get DATA_TYPE_CHANGES() {
    return localizer.getText('DATA_MODEL_CONSTANTS_DATA_TYPE_CHANGES');
  },
  get DELETED_FIELD() {
    return localizer.getText('DATA_MODEL_CONSTANTS_DELETED_FIELD');
  },
  get CHANGED_INDICATOR() {
    return localizer.getText('DATA_MODEL_CONSTANTS_CHANGED_INDICATOR');
  },
  get TENANT_FIELD() {
    return localizer.getText('COMMON_LABEL_TENANT_FIELD');
  },
  DEFAULT_TABLE_HEIGHT: 238,
  DEFAULT_REST_HEIGHT: 36,
  DEFAULT_DETAIL_REST_HEIGHT: 326,

  get TableDefinition() {
    return {
      /* Settings > Data Setup > Data Model: Tables, Views, Stored procedure, Functions */
      get QuerySourceType() {
        return {
          category: {
            columnKey: 'Category',
            width: 250,
            title: localizer.getText('DATA_MODEL_CONSTANTS_TITLE_QUERY_SOURCE_TYPE_CATEGORY'),
            sortable: true
          },
          dbName: {
            columnKey: 'DatabaseName',
            width: 250,
            title: localizer.getText('DATA_MODEL_CONSTANTS_TITLE_QUERY_SOURCE_TYPE_DATABASE_NAME'),
            sortable: true
          },
          dbSourceName: {
            columnKey: 'DataSourceName',
            width: 250,
            title: localizer.getText('DATA_MODEL_CONSTANTS_TITLE_QUERY_SOURCE_TYPE_SOURCE_NAME'),
            sortable: true
          },
          functionName: {
            columnKey: 'DataSourceName',
            width: 250,
            title: localizer.getText('DATA_MODEL_CONSTANTS_TITLE_QUERY_SOURCE_TYPE_FUNCTION_NAME'),
            sortable: true
          },
          dbSourceAlias: {
            columnKey: 'DataSourceAlias',
            width: 250,
            title: localizer.getText('DATA_MODEL_CONSTANTS_TITLE_QUERY_SOURCE_TYPE_SOURCE_ALIAS'),
            sortable: true
          },
          returnedValue: {
            columnKey: 'returnedValue',
            width: 200,
            title: localizer.getText('DATA_MODEL_CONSTANTS_TITLE_QUERY_SOURCE_TYPE_RETURNED_VALUE')
          },
          inputParams: {
            columnKey: 'inputParams',
            width: 190,
            title: localizer.getText('DATA_MODEL_CONSTANTS_TITLE_QUERY_SOURCE_TYPE_INPUT_PARAMS')
          },
          fieldLevel: {
            columnKey: 'fieldLevel',
            width: 160,
            title: localizer.getText('DATA_MODEL_CONSTANTS_TITLE_QUERY_SOURCE_TYPE_FIELD_LEVEL')
          },
          expressionLevel: {
            columnKey: 'expressionLevel',
            width: 200,
            title: localizer.getText('DATA_MODEL_CONSTANTS_TITLE_QUERY_SOURCE_TYPE_EXPRESSION_LEVEL')
          },
          dynamic: {
            columnKey: 'dynamic',
            width: 100,
            title: localizer.getText('DATA_MODEL_CONSTANTS_TITLE_QUERY_SOURCE_TYPE_DYNAMIC'),
            fixed: true
          },
          controlBtn: { columnKey: 'controlBtn', width: 70, fixed: true }
        };
      },

      /* Settings > Data Setup > Data Model > Fields: Tables, Views, Stored procedure, Functions */
      get QuerySourceTypeDetails() {
        return {
          columnName: {
            columnKey: 'ColumnName',
            width: 250,
            title: localizer.getText('DATA_MODEL_CONSTANTS_TITLE_QUERY_SOURCE_TYPE_DETAIL_COLUMN_NAME'),
            sortable: true
          },
          dataType: {
            columnKey: 'DataType',
            width: 200,
            title: localizer.getText('COMMON_LABEL_DATA_TYPE'),
            sortable: true
          },
          columnAlias: {
            columnKey: 'ColumnAlias',
            width: 250,
            title: localizer.getText('DATA_MODEL_CONSTANTS_TITLE_QUERY_SOURCE_TYPE_DETAIL_COLUMN_ALIAS'),
            sortable: true
          },
          filter: {
            columnKey: 'filter',
            width: 300,
            title: localizer.getText('DATA_MODEL_CONSTANTS_TITLE_QUERY_SOURCE_TYPE_DETAIL_FILTER_VALUE')
          },
          visible: {
            columnKey: 'visible',
            width: 80,
            fixed: true,
            title: localizer.getText('COMMON_LABEL_VISIBLE')
          },
          filterable: {
            columnKey: 'filterable',
            width: 80,
            fixed: true,
            title: localizer.getText('DATA_MODEL_CONSTANTS_TITLE_QUERY_SOURCE_TYPE_DETAIL_FILTERABLE')
          },
          deletable: { columnKey: 'deletable', width: 50, fixed: true }
        };
      },

      /* Settings > Data Setup > Data Model: Relationship */
      get Relationship() {
        return {
          joinType: {
            columnKey: 'joinType',
            width: 105,
            title: localizer.getText('COMMON_LABEL_JOIN_TYPE'),
            sortable: false
          },
          positionId: {
            columnKey: 'PositionId',
            width: 105,
            title: localizer.getText('COMMON_LABEL_POSITION'),
            sortable: true
          },
          dbName: {
            columnKey: 'DatabaseName',
            width: 150,
            title: localizer.getText('COMMON_LABEL_DATABASE_NAME'),
            sortable: true
          },
          dataObject: {
            columnKey: 'DataObject',
            width: 180,
            title: localizer.getText('COMMON_LABEL_DATA_OBJECT'),
            sortable: true
          },
          joinField: {
            columnKey: 'JoinField',
            width: 150,
            title: localizer.getText('DATA_MODEL_CONSTANTS_RELATIONSHIP_JOIN_FIELD'),
            sortable: true
          },
          equal: { columnKey: 'equal', width: 40, title: '', sortable: false, fixed: true },
          frDbName: {
            columnKey: 'ForeignDatabaseName',
            width: 150,
            title: localizer.getText('COMMON_LABEL_DATABASE_NAME'),
            sortable: true
          },
          frDataObject: {
            columnKey: 'ForeignDataObject',
            width: 180,
            title: localizer.getText('COMMON_LABEL_FOREIGN_DATA_OBJECT'),
            sortable: true
          },
          frField: {
            columnKey: 'Field',
            width: 150,
            title: localizer.getText('DATA_MODEL_CONSTANTS_RELATIONSHIP_FIELD'),
            sortable: true
          },
          action: { columnKey: 'action', width: 100, title: '', sortable: false, fixed: true }
        };
      }
    };
  },
  EXPRESSION_SELECTION: {
    FIELD_NAME: {
      enableDataSource: false,
      returnedOnlyFieldNameFormat: '[{0}]'
    }
  },
  DEFAULT_SEARCH_PROPERTY: 'All'
};



// WEBPACK FOOTER //
// ./ui/logic/data/Izenda.DataModelConstants.js